
const uploadFile = async (file) => {
    try {

        const formData = new FormData();
        formData.append('file', file);

        // Adjust the path as needed; this assumes a 'public/uploads' folder in the project
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/upload_image`, {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const result = await response.json();
            return result.filename; // Assuming the server returns the filename
        } else {
            console.error('Failed to upload file');
            return null;
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        return null;
    }
};

export default uploadFile;
